import styles from "../../styles/components/FilePreview.module.scss";
import { useOnClickOutside } from "@qastanfit/qastan-ui";
import React, { MutableRefObject, useEffect, useRef, useState } from "react";
import { Button } from "../ui/button";

import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { RootState } from "../../store";

import { downloadFile } from "../../functions/actions/documents";

import toast from 'react-hot-toast'

import { setFavoriteDocuments, setNotification } from "../../redux/actions";
import SendMail from "./SendMail";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "../ui/alert-dialog";
import axios from "src/axios/axios";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from "../ui/sheet";
import { isInterface } from "../../functions/general/checks";
import { ArchiveRestore, Calendar, Clock, CloudIcon, DownloadIcon, Eye, FilePlus, FileType, HeartIcon, History, Mail, MessageSquareIcon, MessageSquareShareIcon, Settings, Trash2, Trash2Icon, User, X } from "lucide-react";
import { YYYYMMDDtoDate } from "../../functions/format";
import { format, isValid } from "date-fns";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown-menu";
import { Input } from "../ui/input";
import { useQuery } from "react-query";
import useAuth from "src/hooks/useAuth";

import Attachments from "./Attachments";
import Remarks from "./Remarks";
import Communication from "./communication/Communication";
import FilePrev from "./file-previewer";

import { useTranslation } from "react-i18next";
import { getWindevLang } from "src/lib/lang";
import { useSelector } from "react-redux";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";
import { Menubar, MenubarContent, MenubarItem, MenubarMenu, MenubarTrigger } from "../ui/menubar";
import EditPreview from "./onedrive/edit-preview";
import { CONFIG } from "src/config";
import Details from "./Details";
import { ScrollArea, ScrollBar } from "../ui/scroll-area";
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from "../ui/resizable";
import { hasDoctypeRight } from "src/lib/filter";

type Props = {
    onClose: () => void;
    document:DocumentObject
}

interface HeaderProps extends Props {
    onSendMail: () => void;
    onViewCommunication: () => void;
    reload?: () => void
}

export interface Message {
    attachments: Attachment[];
    recipients:  Recipient[];
    senderName:  string;
    senderEmail: string;
    subject:     string;
    body:        string;
    headers:     string;
}

export interface Attachment {
    extension:     string;
    dataId:        number;
    contentLength: number;
    fileName:      string;
    fileNameShort: string;
    name:          string;
    pidContentId?: string;
}

export interface Recipient {
    name:  string;
    email: string;
}

export interface MessageHeaders {
    received:                  string;
    results:                   string;
    type:                      string;
    encoding:                  string;
    from:                      string;
    to:                        string;
    cc:                        string;
    subject:                   string;
    topic:                     string;
    index:                     string;
    date:                      string;
    language:                  string;
    attach:                    string;
    scl:                       string;
    version:                   string;
    messagedirectionality:     string;
    authsource:                string;
    authas:                    string;
    authmechanism:             string;
    publictraffictype:         string;
    path:                      string;
    expirationstarttime:       string;
    expirationstarttimereason: string;
    expirationinterval:        string;
    expirationintervalreason:  string;
    id:                        string;
    traffictypediagnostic:     string;
    oobclassifiers:            string;
    antispam:                  string;
    originalarrivaltime:       string;
    fromentityheader:          string;
    mailboxtype:               string;
    userprincipalname:         string;
    crosstenantheadersstamped: string;
    endtoendlatency:           string;
    bccfoldering:              string;
}

interface ToolbarProps {
    document: DocumentObject;
    reload?: () => void
}

const DeleteDocument : React.FC<ToolbarProps> = ({document}) => {
    const {auth} = useAuth()
    const {t} = useTranslation()

    const [is_loading, setis_loading] = useState(false);

    async function handleDeleteDocument() {
        try {
            setis_loading(true)
            toast.loading(t('Document verwijderen'), {id:'deleteDocument'})
            const { data } = await axios.delete(`documents/delete?docid=${document.docid}`)
            if(data.errorcode!==0){console.log(data); throw new Error(data.message)}
            toast.success(t('Document verwijderd'), {id:'deleteDocument'})
        } catch (error) {
            toast.error(t('Document verwijderen mislukt'), {id:'deleteDocument'})
            console.log(error)
        }
        finally {
            setis_loading(false)
        }
    }

    return (
        <>
        <AlertDialog>
            <AlertDialogTrigger asChild>   
                <button className='flex items-center gap-2 py-1 font-medium'>
                    <Trash2Icon className="w-4 h-4"/>
                    {t('Verwijder document')}
                </button>
            </AlertDialogTrigger>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>{t('Bent u zeker')}</AlertDialogTitle>
                    <AlertDialogDescription>{t('U staat op het punt om dit document te verwijderen')}</AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel>{t('Annuleren')}</AlertDialogCancel>
                    <AlertDialogAction disabled={is_loading} onClick={()=>{handleDeleteDocument()}}>{is_loading ? t('Even geduld') : t('Verwijderen')}</AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
        </>
    )
}

const HistoryDocument : React.FC<ToolbarProps> = ({document}) => {
    const {auth} = useAuth()
    const {t, i18n} = useTranslation()

    const colleagues:ForwardUser[] = useAppSelector((state:RootState)=>state.colleagues)
    const doctypes:DoctypeObject[] = useAppSelector((state:RootState)=>state.doctypes)

    const [history, sethistory] = useState<HistoryDocument[] | StateType>(null);

    async function getHistory() {
        try {
            toast.loading(t('Historiek ophalen'), { id:'historyDocument' })
            sethistory('loading')
            const {data} = await axios.get(`documents/history?docid=${document.docid}`)
            if(data.errorcode !== 0) { toast.error(t('Error bij het ophalen van de historiek'), { id:'historyDocument' }); sethistory('error') }
            else {
                if(!Array.isArray(data.object) || data.object.length < 1) { sethistory('empty'); return; }
                sethistory(data.object)
                toast.remove('historyDocument')

                console.log(data);

            }
        } catch (error) {
            toast.error(t('Error bij het ophalen van de historiek'), { id:'historyDocument' })
            sethistory('error')
            console.log(error)
        }
    }

    function usernameToName(name:string) {
        let n = name
        const user = Array.isArray(colleagues) ? colleagues.find(u=>u.username.toLowerCase() === name.toLowerCase()) : undefined
        if(user){
            n = `${user.firstname} ${user.name}`
        }
        return n
    }

    function doctypeToName(doct:string) {
        let n = doct
        const doctype = Array.isArray(doctypes) ? doctypes.find(u=>u.doctype.toLowerCase() === doct.toLowerCase()) : undefined
        if(doctype){
            n = `${doctype.docoms.find(i => i.nationid === getWindevLang(i18n.language))?.oms}`
        }
        return n
    }

    return (
        <>
        <Sheet>
            <SheetTrigger asChild>
                <button onClick={()=>{getHistory()}} className="flex items-center gap-2 py-1 font-medium">
                    <Clock className="w-4 h-4"/>
                    {t('Historiek document')}
                </button>
            </SheetTrigger>
            <SheetContent position="right" className="h-screen overflow-auto z-[51]">
                <SheetHeader className="mb-4">
                    <SheetTitle>{t('Historiek')}</SheetTitle>
                    <SheetDescription>{t('Hieronder vindt u de historiek van dit document')}</SheetDescription>
                </SheetHeader>

                {history === 'loading' && <p>{t('Even geduld')}...</p>}
                {history === 'empty' && <p>{t('Geen historiek gevonden')}</p>}
                {isInterface(history, {} as HistoryDocument[]) && 
                <div className="flex flex-col gap-3">
                    {history.map((document, index) => {
                        return (
                            <div className="p-2 border rounded-sm" key={index}>
                                <div className="flex justify-between">
                                    <p className="font-semibold">{document.filename}</p>
                                    <DropdownMenu>
                                        <DropdownMenuTrigger asChild><button className="hidden text-neutral-500 hover:text-neutral-700"><Settings className="w-5"/></button></DropdownMenuTrigger>
                                        <DropdownMenuContent className="z-[52]">
                                            <DropdownMenuItem><Eye className="w-4 mr-2 text-neutral-500"/><span>{('Open')}</span></DropdownMenuItem>
                                            <DropdownMenuItem><ArchiveRestore className="w-4 mr-2 text-neutral-500"/><span>{t('Herstellen')}</span></DropdownMenuItem>
                                            <DropdownMenuItem><Mail className="w-4 mr-2 text-neutral-500"/><span>{t('Email document')}</span></DropdownMenuItem>
                                            <DropdownMenuItem><Trash2 className="w-4 mr-2 text-neutral-500"/><span>{t('Verwijderen')}</span></DropdownMenuItem>
                                        </DropdownMenuContent>
                                    </DropdownMenu>
                                </div>
                                
                                <div className="grid grid-cols-2">
                                    <p className="flex items-center gap-1 text-sm text-neutral-500"><span><Calendar className="w-4"/></span>{format(YYYYMMDDtoDate(document.docdate), "dd/MM/yyyy")}</p>
                                    <p className="flex items-center gap-1 text-sm text-neutral-500"><span><History className="w-4"/></span>{t('Versie')} {document.version}</p>
                                    <p className="flex items-center gap-1 text-sm text-neutral-500"><span><User className="w-4"/></span> {usernameToName(document.user)}</p>
                                    <p className="flex items-center gap-1 text-sm text-neutral-500"><span><FileType className="w-4"/></span>{doctypeToName(document.doctype)}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
                }

            </SheetContent>
        </Sheet>
        </>
    )
}

const NewVersionDocument : React.FC<ToolbarProps> = ({document}) => {
    const {t} = useTranslation()
    const {auth} = useAuth()

    const [is_loading, setis_loading] = useState(false);
    const [new_version, setnew_version] = useState<{ token: string; filename: string; file: string; docid: number; }>();

    function addDocument(event: React.ChangeEvent<HTMLInputElement>) {
        const file = event.target.files?.[0];

        if (file) {
        const reader = new FileReader();

        reader.onloadend = () => {
            let base = reader.result as string
            //base = base.split('base64,')[1]
            console.log(base)
            setnew_version({
                token: auth.data?.token || '',
                filename: file.name,
                file: base,
                docid: document.docid
            });
        };

        reader.readAsDataURL(file);
        //setSelectedFile(file);
        }
    }

    async function saveDocument() {
        try {
            setis_loading(true)
            toast.loading(t('Document wijzigen'), {id:'newVersion'})
            console.log(new_version)
            const {data} = await axios.post(`documents/addversion`, new_version)
            console.log(data);
            if(data.errorcode !== 0) { throw new Error(data.message) }
            toast.success(t('Versie toegevoegd'), {id:'newVersion'})
        } catch (error) {
            console.log(error)
            toast.error(t('Document toevoegen mislukt'), {id:'newVersion'})
        } finally {
            setis_loading(false)
        }
    }

    return (
        <AlertDialog>
            <AlertDialogTrigger asChild>
                <button className="flex items-center gap-2 py-1 font-medium">
                    <FilePlus className="w-4 h-4"/>
                    {t('Nieuwe versie doc')}
                </button>
            </AlertDialogTrigger>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>{t('Nieuwe versie')}</AlertDialogTitle>
                    <AlertDialogDescription>{t('U staat op het punt om dit document te wijzigen door een nieuwe versie')}</AlertDialogDescription>
                </AlertDialogHeader>

                <div>
                    <Input onChange={addDocument} type='file' className="cursor-pointer"/>
                </div>

                <AlertDialogFooter>
                    <AlertDialogCancel>{t('Annuleren')}</AlertDialogCancel>
                    <AlertDialogAction disabled={(new_version === undefined || is_loading)} onClick={()=>{saveDocument()}}>{is_loading ? t('Even geduld') : t('Document toevoegen')}</AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}

const Toolbar : React.FC<ToolbarProps> = ({document, reload}) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const doctypes = useAppSelector((state:RootState)=>state.doctypes)
    const { auth } = useAuth()
    const toolbarRef = useRef() as MutableRefObject<HTMLDivElement>;
    useOnClickOutside(toolbarRef, () => {setshow_menu("")})    
    const [show_menu, setshow_menu] = useState("");

    async function handleDownload() {
        if(!document) return;
        dispatch(setNotification({type:'pending', title:t('Even geduld'), message:t('Document downloaden')}))
        let {data:d}= await axios.get(`documents/get?docid=${document.docid}`)
        if(d.errorcode === 0){
            downloadFile(d.object.file, document.filename)
            dispatch(setNotification({type:'success', title:t('Succes'), message:t('Document gedownload')}))
        }
        else {
            dispatch(setNotification({type:'error', title:t('Error'), message:t('Document downloaden mislukt')}))
            //Could not download document
        }
    }

    return (
        <>
        <Menubar className="-translate-x-4 bg-transparent border-none">
            <MenubarMenu>
                <MenubarTrigger>{t('Bestand')}</MenubarTrigger>
                <MenubarContent className="!z-[51] space-y-1">
                    <MenubarItem onSelect={(e)=>{e.preventDefault()}}><button onClick={()=>{handleDownload()}} className="flex items-center gap-2 py-1 font-medium"><DownloadIcon className="w-4 h-4"/>{t('Downloaden')}</button></MenubarItem>
                    <MenubarItem onSelect={(e)=>{e.preventDefault()}}><NewVersionDocument document={document} /></MenubarItem>
                    <MenubarItem onSelect={(e)=>{e.preventDefault()}}><HistoryDocument document={document}/></MenubarItem>
                    <MenubarItem onSelect={(e)=>{e.preventDefault()}}><DeleteDocument document={document}/></MenubarItem>
                </MenubarContent>
            </MenubarMenu>
            {CONFIG.onedrive.enable &&
            <MenubarMenu>
                <MenubarTrigger>Bewerken</MenubarTrigger>
                <MenubarContent className="!z-[51] space-y-1">
                    <MenubarItem onSelect={(e)=>{e.preventDefault()}}><EditPreview onReload={()=>{reload&&reload()}} docId={document.docid} trigger={<button className="flex items-center gap-2 py-1 font-medium"><CloudIcon className="w-4 h-4"/>Bewerk in online editor</button>}/></MenubarItem>
                </MenubarContent>
            </MenubarMenu>
            }
        </Menubar>

        <div ref={toolbarRef} className={`${styles.toolbar} !hidden`}>
            <div className={styles.menu}>
                <button onClick={()=>{setshow_menu("file")}} className={styles.menu_item}>{t('Bestand')}</button>
                <div className={`${show_menu !== "file" && styles.menu_list_hidden} ${styles.menu_list}`}>

                    {hasDoctypeRight(document.doctype, doctypes, 'print') &&
                    <button onClick={()=>{handleDownload()}} className={styles.menu_list_option}>
                        <div className={styles.icon}><svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg></div>
                        <p className={styles.label}>{t('Downloaden')}</p>
                    </button>
                    }

                    {hasDoctypeRight(document.doctype, doctypes, 'update') &&
                    <NewVersionDocument document={document} />
                    }

                    {hasDoctypeRight(document.doctype, doctypes, 'view') &&
                    <HistoryDocument document={document}/>
                    }

                    {hasDoctypeRight(document.doctype, doctypes, 'delete') &&
                    <DeleteDocument document={document}/>
                    }
                </div>
            </div>

            {/* <div className='hidden'>
                <button onClick={()=>{setshow_menu("edit")}} className={styles.menu_item}>Bewerken</button>
                <div className={`${show_menu !== "edit" && styles.menu_list_hidden} ${styles.menu_list}`}>
                    <button className={styles.menu_list_option}>
                        <div className={styles.icon}><svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg></div>
                        <p className={styles.label}>Metadata aanpassen</p>
                    </button>

                    <button className={styles.menu_list_option}>
                        <div className={styles.icon}><svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg></div>
                        <p className={styles.label}>Naam aanpassen</p>
                    </button>
                </div>
            </div> */}

            <div className={styles.menu}>
                <button onClick={()=>{setshow_menu("extra")}} className={styles.menu_item}>Extra</button>
                <div className={`${show_menu !== "extra" && styles.menu_list_hidden} ${styles.menu_list}`}>
                    <button className={styles.menu_list_option}>
                        <div className={styles.icon}><svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg></div>
                        <p className={styles.label}>{t('Favoriet maken')}</p>
                    </button>
                </div>
            </div>
        </div>
        </>
    )
}

const Header : React.FC<HeaderProps> = ({onSendMail, onClose, onViewCommunication, reload, document}) => {
    const {t} = useTranslation()
    const dispatch = useAppDispatch();
    const doctypes = useAppSelector((state:RootState)=>state.doctypes);
    const {auth} = useAuth()
    const favoriteDocuments:DocumentObject[] = useAppSelector((state:RootState) => state.favoriteDocuments)

    const handleFavoriteFile = async (item:DocumentObject) => {
        
        try {
            let tmp_favoriteDocuments = [...favoriteDocuments];
            const index = tmp_favoriteDocuments.findIndex(i => i.docid === item.docid)
            if(index === -1){
                dispatch(setNotification({type:'pending', title:t('Even geduld'), message:t('Het document wordt bij uw favorieten toegevoegd')}))
                let {data:res} = await axios.post(`favorites/add`, { token:auth.data?.token, docid:item.docid })
                if(res.errorcode === 0){
                    tmp_favoriteDocuments.push(item);
                    dispatch(setFavoriteDocuments(tmp_favoriteDocuments))
                    dispatch(setNotification({type:'success', title:t('Succes'), message:t('Uw document werd toegevoegd aan favorieten')}))
                }
                else {
                    console.log(res)
                    dispatch(setNotification({type:'error', title:t('Error'), message:t('Er liep iets mis bij het toevoegen aan favorieten')}))
                }
            }
            else {
                dispatch(setNotification({type:'pending', title:t('Even geduld'), message:t('Het document wordt verwijderd uit uw favorieten')}))
                let {data:res} = await axios.delete(`favorites/delete?docid=${item.docid}`)
                if(res.errorcode === 0){
                    tmp_favoriteDocuments.splice(index, 1)
                    dispatch(setFavoriteDocuments(tmp_favoriteDocuments))
                    dispatch(setNotification({type:'success', title:t('Succes'), message:t('Uw document werd verwijderd uit favorieten')}))
                }
                else {
                    console.log(res)
                    dispatch(setNotification({type:'error', title:t('Error'), message:t('Er liep iets mis bij het verwijderen aan favorieten')}))
                }
            }
        } catch (e) {
            dispatch(setNotification({type:'error', title:t('Error'), message:t('Er liep iets mis')}))
        }
    }

    return (
        <>
        <TooltipProvider>
        <div className={`h-[100px] sm:min-h-[100px] bg-white flex justify-between items-center relative z-10`}>
            <div className={`flex items-center h-full w-full`}>
                <div onClick={()=>{onClose()}} className={`w-14 sm:w-[100px] flex justify-center`}>
                    <button className={`w-8 h-8 sm:bg-slate-200 text-slate-600 rounded-full flex justify-center items-center`}>
                        <X className="w-4 h-4"/>
                    </button>
                </div>

                <div className='flex flex-col justify-between w-full h-full'>
                    <div className='flex items-center gap-3 pt-4'>
                        <p className='font-medium'>{document.filename}</p>
                        <button onClick={()=>{handleFavoriteFile(document)}} className={`${favoriteDocuments.findIndex(i => i.docid.toString() === document.docid.toString()) > -1 ? 'text-primary' : 'text-neutral-400 hover:text-neutral-700'}`}>
                            <HeartIcon className={`w-4 h-4 ${favoriteDocuments.findIndex(i => i.docid.toString() === document.docid.toString()) > -1 && 'fill-primary'}`}/>
                        </button>
                    </div>

                    <Toolbar document={document} reload={()=>{reload&&reload()}}/>
                </div>
            </div>
            
            <div className='items-center hidden gap-2 pr-4 sm:flex'>
                <Tooltip delayDuration={50}>
                    <TooltipTrigger asChild>
                        <Button onClick={()=>{onViewCommunication()}} variant='ghost' className="w-10 h-10 p-0 rounded-full text-neutral-600"><MessageSquareShareIcon className="w-5 h-5"/></Button>
                    </TooltipTrigger>
                    <TooltipContent>
                        <p>Communicatie in nieuw tab openen</p>
                    </TooltipContent>
                </Tooltip>

                {hasDoctypeRight(document.doctype, doctypes, 'email') &&
                <Button onClick={()=>{ onSendMail() }}>{t('Mail versturen')}</Button>
                }
            </div>
        </div>
        </TooltipProvider>
        </>
    )
}

type TabsType = 'preview' | 'details' | 'comments' | 'attachments' | 'communication'

type TabsProps = {
    changeTab: (tab:TabsType) => void
    activeTab: TabsType
    communication?: Communcation[] | null
    attachments?: any
    document?: DocumentObject
}

const Tabs : React.FC<TabsProps> = ({changeTab, activeTab, communication, attachments, document}) => {
    const { t } = useTranslation()
    const [show_tabs, setshow_tabs] = useState(false);

    const tabsRef = useRef() as MutableRefObject<HTMLDivElement>;
    

    useOnClickOutside(tabsRef, () => { if(show_tabs){ setshow_tabs(!show_tabs) } })

    return (
        <ScrollArea className="mx-2 h-14">
            <div className="flex justify-center h-10 rounded-full min-h-10">
                <div className="flex items-center h-full gap-1 p-1 bg-white rounded-full">
                    <button onClick={()=>{changeTab('preview')}} className={`${activeTab === 'preview' ? 'bg-slate-100 font-medium border-slate-200' : 'font-normal border-transparent'} h-8 rounded-full text-sm px-2 border border-solid whitespace-nowrap`}>Preview</button>
                    <button onClick={()=>{changeTab('details')}} className={`${activeTab === 'details' ? 'bg-slate-100 font-medium border-slate-200' : 'font-normal border-transparent'} h-8 rounded-full text-sm px-2 border border-solid whitespace-nowrap`}>Details</button>
                    <button onClick={()=>{changeTab('comments')}} className={`${activeTab === 'comments' ? 'bg-slate-100 font-medium border-slate-200' : 'font-normal border-transparent'} h-8 rounded-full text-sm px-2 border border-solid whitespace-nowrap`}>Opmerkingen ({document?.remarks ? (document.remarks.length || '0') : '0'})</button>
                    <button onClick={()=>{changeTab('attachments')}} className={`${activeTab === 'attachments' ? 'bg-slate-100 font-medium border-slate-200' : 'font-normal border-transparent'} h-8 rounded-full text-sm px-2 border border-solid whitespace-nowrap`}>Bijlages ({document ? (document.attachments ? document.attachments.length : '0') : '0'})</button>
                    <button onClick={()=>{changeTab('communication')}} className={`${activeTab === 'communication' ? 'bg-slate-100 font-medium border-slate-200' : 'font-normal border-transparent'} h-8 rounded-full text-sm px-2 border border-solid whitespace-nowrap`}>Communicatie ({communication ? communication.length : '0'})</button>
                </div>
            </div>
            <ScrollBar orientation="horizontal"/>
        </ScrollArea>
    )
}

const FilePreview : React.FC<Props> = ({onClose, document}) => {
    const {t, i18n} = useTranslation()

    const doctypes = useAppSelector((state:RootState)=>state.doctypes);

    const {auth} = useAuth()

    const [full_file, setfull_file] = useState<any>();
    
    const [activeTab, setactiveTab] = useState<TabsType>('preview');

    const [show_sendmail, setshow_sendmail] = useState(false);
    const [show_split_communication, setshow_split_communication] = useState(false);

    const {data:communication, refetch:refetchCommunication } = useQuery<Communcation[] | null>({
        queryKey: [`communication_${document.docid}`],
        queryFn: async () => {
            try {
                const {data} = await axios.get(`communications/get?docid=${document.docid}`)
                if(data.errorcode!==0){throw new Error(data.message)}
                if(!Array.isArray(data.object)){throw new Error('empty')}
                return data.object
            } catch (error) {
                return null
            }
        }
    })

    const {data:attachments} = useQuery({
        queryKey: [`attachments`],
        queryFn: async () => {
            try {
                
            } catch (error) {
                console.log(error);
                return null
            }
        }
    })

    useEffect(()=>{
        getDocURL()

        const handleKeyPress = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
              onClose()
            }
        };

        // Attach the event listener when the component mounts
        window.document.addEventListener('keydown', handleKeyPress);

        // Detach the event listener when the component unmounts
        return () => {
            window.document.removeEventListener('keydown', handleKeyPress);
        };
    }, [])

    const getDocURL = async () => {
        toast.loading(`${t('Document ophalen')}...`, {id:'getDoc', position:'bottom-center'})
        let {data:d} = await axios.get(`documents/get?docid=${document.docid}`)
        toast.remove('getDoc')
        console.log(d)
        if(d.errorcode === 0){
            setfull_file(d.object);
        }
        else {
            return;
        }
    }

    return (
        <div className={`${styles.filepreview} gap-3 w-dvw h-dvh max-h-dvh fixed top-0 left-0 z-[51] flex flex-col justify-between bg-black/60`}>
            <Header onSendMail={()=>{ setshow_sendmail(true) }} onViewCommunication={()=>{ setshow_split_communication(true) }} document={document} reload={()=>{getDocURL()}} onClose={()=>{onClose()}}/>

            <Tabs changeTab={(tab:TabsType)=>{setactiveTab(tab)}} activeTab={activeTab} communication={communication} attachments={attachments} document={document}/>

            <div className="flex flex-col h-full overflow-auto">
                <TooltipProvider>
                
                <ResizablePanelGroup direction="horizontal" className="mx-auto items-end w-full max-w-[700px] lg:max-w-[90dvw] min-w-[40dvw] lg:w-fit bg-white rounded-t-xl h-full">
                    <ResizablePanel className="h-full">
                    {activeTab === 'preview' && 
                        <div className="flex w-full h-full overflow-auto">
                            
                            {(full_file && 'file' in full_file && 'filename' in full_file) && 
                            <ScrollArea className="flex w-full p-3" id='file-preview-scroll-area'>
                                <div className="relative w-full h-full">
                                    <FilePrev base64={full_file.file} extension={full_file.filename.split('.')[full_file.filename.split('.').length-1].toLowerCase()}/>
                                </div>
                                <ScrollBar orientation="horizontal"/>
                            </ScrollArea>  
                            }
                        </div>
                    }

                    {activeTab === 'details' &&
                        <div className="w-full h-full">
                            <ScrollArea className="flex w-full h-full p-3">
                                <div>
                                    <Details document={document}/>
                                </div>
                            </ScrollArea>
                        </div>
                    }

                    {activeTab === 'comments' &&
                        <div className="w-full h-full">
                            <ScrollArea className="flex w-full h-full p-3">
                                <div>
                                    {isInterface(document.remarks, {} as Remark[]) && <Remarks remarks={document.remarks}/>}
                                    {!isInterface(document.remarks, {} as Remark[]) && <p>{t('Geen opmerkingen gevonden')}</p>}
                                </div>
                            </ScrollArea>
                        </div>
                    }

                    {activeTab === 'attachments' &&
                        <div className="w-full h-full">
                            <ScrollArea className="flex w-full h-full p-3">
                                <div>
                                    <Attachments document={document}/>
                                </div>
                            </ScrollArea>
                        </div>
                    }

                    {activeTab === 'communication' &&
                        <div className="w-full h-full">
                            <ScrollArea className="flex w-full h-full p-3">
                                <div>
                                    <Communication communication={communication} onSuccess={()=>{refetchCommunication()}} document={document}/>
                                </div>
                            </ScrollArea>
                        </div>
                    }
                    </ResizablePanel>

                    {show_split_communication &&
                    <>
                    <ResizableHandle className="h-full" withHandle/>
                    <ResizablePanel className="h-full" defaultSize={25}>
                        <div className="w-full min-w-[320px] p-4 flex h-full">
                            <div className="flex flex-col w-full h-full bg-slate-100 rounded-xl">
                                <div className="flex justify-between gap-4 p-3 border-b">
                                    <p className="text-lg font-medium">Communicatie</p>
                                    <button className="flex items-center justify-center w-8 h-8 rounded-full text-neutral-600" onClick={()=>{setshow_split_communication(false)}}><X className="w-5 h-5"/></button>
                                </div>
                                <ScrollArea className="h-full">
                                    <div className="flex flex-col h-full p-3">
                                        <Communication communication={communication} onSuccess={()=>{refetchCommunication()}} document={document} addMessageType="inline"/>
                                    </div>
                                </ScrollArea>
                            </div>
                        </div>
                    </ResizablePanel>
                    </>
                    }
                </ResizablePanelGroup>

                </TooltipProvider>
            </div>

            <SendMail document={full_file} onClose={()=>{ setshow_sendmail(false) }} className={`${!show_sendmail && 'hidden'}`}/>
        </div>

        
    )
}

export default FilePreview;